module.exports = __webpack_public_path__ + "img/romania.49e0cfe.webp";